import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { CaseRequestDto } from '../../models/dto/case-overview/case-request-dto.model';
import { ReferenceDataSwitchCaseStatus } from '../../constants/reference-data-switch-case-status';

@Component({
  selector: 'boi-overview-switch-offer-status',
  templateUrl: './overview-switch-offer-status.component.html'
})
export class OverviewSwitchOfferStatusComponent {
  @Input() public caseRequest: CaseRequestDto;
  @Input() public interfaceTypeCode: string;
  @Input() public caseIdAsHash: string;

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public referenceDataSwitchCaseStatus = ReferenceDataSwitchCaseStatus;

  public inProgressStatusesList = [
    this.referenceDataSwitchCaseStatus.SwitchRequested,
    this.referenceDataSwitchCaseStatus.SwitchDownloadPending,
    this.referenceDataSwitchCaseStatus.SwitchDownloadFailed,
    this.referenceDataSwitchCaseStatus.SwitchManualProcessing,
    this.referenceDataSwitchCaseStatus.SwitchInProgress
  ];

  public readyStatusesList = [
    this.referenceDataSwitchCaseStatus.SwitchOfferIssuedOnline,
    this.referenceDataSwitchCaseStatus.SwitchOfferIssuedPostal,
    this.referenceDataSwitchCaseStatus.SwitchOfferIssuedForcedPostal
  ];

  public notProceedingStatusesList = [
    this.referenceDataSwitchCaseStatus.SwitchNotProceeding,
    this.referenceDataSwitchCaseStatus.SwitchDropped,
    this.referenceDataSwitchCaseStatus.SwitchDeclined
  ];

  public offerExpiredStatus = this.referenceDataSwitchCaseStatus.SwitchOfferExpired;
}
